import React, { memo } from 'react';

import { PickersDayProps as MuiPickersDayProps } from '@mui/x-date-pickers';
import type {} from '@mui/x-date-pickers/AdapterLuxon';
import { DateTime } from 'luxon';

import { CustomPickersDay } from './styled';

export type PickersDayProps = MuiPickersDayProps<DateTime> & {
	isStartDate?: boolean;
	isEndDate?: boolean;
	isInRange: boolean;
	isHovered?: boolean;
	isSameDate?: boolean;
};

function DateRangePickerDay({
	isStartDate,
	isEndDate,
	isInRange,
	isHovered,
	isSameDate,
	day,
	...props
}: PickersDayProps) {
	return (
		<CustomPickersDay
			{...props}
			day={day}
			isEndDate={isEndDate}
			isStartDate={isStartDate}
			isInRange={isInRange}
			isHovered={isHovered}
			isSameDate={isSameDate}
		/>
	);
}

export default memo(
	DateRangePickerDay,
	(prev, next) =>
		prev.isStartDate === next.isStartDate &&
		prev.isEndDate === next.isEndDate &&
		prev.isInRange === next.isInRange &&
		prev.isHovered === next.isHovered &&
		prev.day === next.day,
);
